export enum RequestTripType {
  Domestic = 'domestic',
  International = 'international',
}
